// extracted by mini-css-extract-plugin
export default {"wishlist__circle":"WishlistButton_wishlist__circle__-0Mfq"};